import { styled } from "@mui/material/styles";
import { Divider, Grid } from "@mui/material";

export const ListsContainer = styled(Grid)({
  display: "flex",
  flexWrap: "nowrap",
});

export const StyledDivider = styled(Divider)({
  height: "auto",
});
